module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.divVisible) ? _c('div', {
    attrs: {
      "id": "mains"
    }
  }, [_c('b', [_vm._v("メイン画面")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _c('br'), _vm._v(" "), (_vm.user.userType == '1' || _vm.user.userType == '3') ? _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'projects',
        params: {}
      }
    }
  }, [_vm._v("プロジェクト情報一覧")]), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'sales',
        params: {}
      }
    }
  }, [_vm._v("管理人月数情報一覧")]), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'questionnaireAnswer',
        params: {}
      }
    }
  }, [_vm._v("評価結果一覧（全員）")]), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'questionnaire',
        params: {
          backScreenId: 'mains'
        }
      }
    }
  }, [_vm._v("評価実施")]), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'questionnaireStatus',
        params: {}
      }
    }
  }, [_vm._v("評価状況一覧")]), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'eloBatch',
        params: {}
      }
    }
  }, [_vm._v("ELOバッチ実行")]), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'questionnaireItemManage',
        params: {}
      }
    }
  }, [_vm._v("評価項目管理（工事中）")]), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'userManage',
        params: {}
      }
    }
  }, [_vm._v("ユーザ管理")]), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'syncAWS',
        params: {}
      }
    }
  }, [_vm._v("AWS同期")]), _c('br'), _c('br')], 1) : (_vm.user.userType == '5') ? _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'sales',
        params: {}
      }
    }
  }, [_vm._v("管理人月数情報一覧（自己）")]), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'questionnaire',
        params: {
          backScreenId: 'mains'
        }
      }
    }
  }, [_vm._v("評価実施")]), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'questionnaireAnswer',
        params: {
          evaluateeMemberID: _vm.user.memberID
        }
      }
    }
  }, [_vm._v("評価結果一覧（自己）")]), _c('br'), _c('br'), _vm._v(" "), _c('br')], 1) : (_vm.user.userType == '7') ? _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'questionnaire',
        params: {
          backScreenId: 'mains'
        }
      }
    }
  }, [_vm._v("評価実施")]), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'questionnaireAnswer',
        params: {
          evaluateeMemberID: _vm.user.memberID
        }
      }
    }
  }, [_vm._v("評価結果一覧（自己）")]), _c('br'), _c('br')], 1) : (_vm.user.userType == '9') ? _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'questionnaire',
        params: {
          backScreenId: 'mains'
        }
      }
    }
  }, [_vm._v("評価実施")]), _c('br'), _c('br')], 1) : (_vm.user.userType == '8') ? _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'questionnaireStatus',
        params: {}
      }
    }
  }, [_vm._v("評価状況一覧")]), _c('br'), _c('br')], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tr', [_c('td', [_vm._v("リンク一覧を参照いただきます。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66be1216!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/mains.vue
// module id = 128
// module chunks = 2